import React from "react";
import { useGuidedTour } from "../GuidedTourProvider";
import { TOUR_ORDER } from "../tours";
import { t } from "../i18n";
import styles from "./WelcomeModal.module.scss";

const WelcomeModal = () => {
  const { welcomeOpen, closeWelcome, startTour, markWelcomeSeen } = useGuidedTour();

  if (!welcomeOpen) return null;

  const handleStart = () => {
    markWelcomeSeen();
    startTour(TOUR_ORDER[0]);
  };

  const handleLater = () => {
    markWelcomeSeen();
    closeWelcome();
  };

  return (
    <div className={styles.backdrop} onClick={handleLater}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.close} onClick={handleLater} aria-label="Close">×</button>
        <div className={styles.memoji} role="img" aria-label="Guide">👩🏻‍💻</div>
        <h2 className={styles.title}>{t("tours.welcome.title")}</h2>
        <p className={styles.body}>{t("tours.welcome.body")}</p>
        <div className={styles.tip}>{t("tours.welcome.helpFromMenu")}</div>
        <button className={styles.primary} onClick={handleStart}>
          {t("tours.welcome.cta")}
        </button>
        <button className={styles.secondary} onClick={handleLater}>
          {t("tours.welcome.laterCta")}
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
